<template>
  <div class="favorite-page c-layout">
    <div class="breadcrumbs c-layout hide-on-pad">
      <span>{{ $t('breadcrumbs.home') }}</span>
      <span class="p-16">/</span>
      <span>{{ $t('breadcrumbs.user_center') }}</span>
      <span class="p-16">/</span>
      <span class="o-color">{{ $t('breadcrumbs.news_center') }}</span>
    </div>
    <div class="page-title">{{ $t('breadcrumbs.news_center') }}</div>
    <div class="page-container">
      <div class="page-left hide-on-pad">
        <user-side-menu page="newsCenter"/>
      </div>
      <div class="page-right step-content">
        <list-view
          @scrollOnBottom="handleOnScrollBottom"
          :showLoading="listLoading"
        >
          <div slot="header-right">{{ $t('news_center.readed') }}</div>
          <div slot="list-container">
            <div class="list-item" v-for="(item,index) in list" :key="index+'_notification'">
              <div class="item-img">
                <div class="notification-img" :style="{ backgroundImage: `url(${item.photo})` }"></div>
              </div>
              <div class="item-content">
                <p class="n-title">{{ item.title }}</p>
                <p class="n-content">{{ item.content }}</p>
                <p class="hide-on-pad">{{ item.editTime }}</p>
              </div>
              <div class="item-btns" v-show="item.url">
                <div class="btn btn-light-grey" @click="handleReadMore(item.url)">{{ $t('btns.read_more') }}</div>
              </div>
              <div class="datetime">{{ item.editTime }}</div>
            </div>
          </div>
        </list-view>
      </div>
    </div>
  </div>
</template>

<script>
import UserSideMenu from '../../components/UserSideMenu'
import ListView from '../../components/ListView'
import { getNotifications, addMemberLike } from '../../api'

  export default {
    name: 'news-center',
    data() {
      return {
        list: [],
        pages: 0,
        count: 10,
        gettingList: false,
        listLoading: true
      }
    },
    components: {
      UserSideMenu,ListView
    },
    async created() {
      this.getList();
    },
    methods: {
      async getList() {
        // 如果已经取完了就不要再读取了
        if(!this.listLoading) return;
        // 如果在取资料中就不要再来了
        if(this.gettingList) return;
        this.gettingList = true;
        this.pages = this.pages + 1;
        const { notifications } = await getNotifications({ pages:this.pages, count:this.count });
        console.log('notifications',notifications);
        if(notifications.length>0) {
          const newList = this.list.concat(notifications);
          this.list = newList;
        }else{
          this.listLoading = false;
        }
        this.gettingList = false
      },
      handleOnScrollBottom() {
        this.getList();
      },
      handleReadMore(url) {
        // if(url) window.open(url, '_blank');
        // if(url) location.href = url;
        this.linkToRouter(linkurl);
      }
    }
  }
</script>

<style lang="less" scoped>
.favorite-page {
  & /deep/ .list-view {
    .list-header {
      border-top: unset;
      border-bottom: unset;
    }
  }
  .list-item {
    display: flex;
    border-bottom: 1px solid #E6E6E6;
    padding: 20px 0;
    .item-img {
      width: 120px;
      .notification-img {
        width: 100%;
        padding-top: 100%;
        background: #F0F0F0;
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
      }
    }
    .item-content {
      flex: 1;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      padding: 5px 20px;
    }
    .item-btns {
      display: flex;
      flex-direction: column;
      justify-content: center;
      .btn {
        width: 125px;
        margin-bottom: 16px;
        &:nth-last-child(1) {
          margin-bottom: 0;
        }
      }
    }
    .datetime {
      display: none;
    }
  }
  .all-add {
    width: 160px;
    margin: auto;
    margin-top: 40px;
    margin-bottom: 40px;
  }
  
  @media (max-width: 992px) {
    background-color: #F7F8FA;  
    .page-container {
      padding-top: 0;
    }
    .list-item {
      background: white;
      padding: 20px;
      border-radius: 6px;
      box-shadow: 2px 4px 6px 2px rgba(0,0,0,.1);
      margin-bottom: 16px;
      border-bottom: unset;
      position: relative;
      .item-img {
        width: 90px;
        .notification-img {
          padding-top: 100%;
          border-radius: 5px;
        }
      }
      .item-content {
        justify-content: center;
        .n-title {
          font-size: 1.2rem;
          margin-bottom: 10px;
        }
        .n-content {
          font-size: 14px;
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-line-clamp: 2;
          -webkit-box-orient: vertical;
        }
      }
      .item-btns {
        display: none;
      }
      .datetime {
        font-size: 12px;
        display: block;
        position: absolute;
        right: 10px;
        bottom: 10px;
      }
    }
  }

}
</style>